import React from "react";
import { useState, Suspense, useEffect } from "react";
import Header from "./Header";
import ContactUs from "./ContactUs";
import WhyUs from "./WhyUs";
import Services from "./Services";
import Gallery from "./Gallery";
import StartImage from "./StartImage";
import BasicHeader from "./BasicHeader";
import AboutUs from "./AboutUs";
import Scroll from "./Scroll";
import LastPage from "./Lastpage";
// import Footer from "./Footer";
import Testimonials from "./Testimonials";
import Videos from "./Videos";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { AiOutlineMail } from "react-icons/ai";
import { IoCallOutline } from "react-icons/io5";
import { SlLocationPin } from "react-icons/sl";
import { HiHome } from "react-icons/hi2";
import { BiMenu } from "react-icons/bi";
import LoginForm from "./LoginForm";
import Map from "./Map";
import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import SignupForm from "./SignupForm";
import { auth } from "./firebase";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { MdLogout } from "react-icons/md";
// Translations
const resources = {
  en: {
    translation: {
      // English translations
      home: "HOME",
      services: "SERVICES",
      aboutUs: "ABOUT US",
      whyUs: "WHY US",
      videos: "VIDEOS",
      gallery: "GALLERY",
      testimonials: "TESTIMONIALS",
      contactUs: "CONTACT US",
      sthapna: "Sthapna",
    },
  },
  hi: {
    translation: {
      // French translations
      home: "घर",
      services: "सेवाएं",
      aboutUs: "हमारे बारे में",
      whyUs: "हमें क्यों चुनें",
      videos: "गैलरी",
      gallery: "वीडियो",
      testimonials: "प्रशंसापत्र",
      contactUs: "संपर्क",
      sthapna: "स्थापना",
    },
  },
  // Add more languages as needed
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Set the default language
  fallbackLng: "en", // Fallback language if the translation is missing
  interpolation: {
    escapeValue: false,
  },
});

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};

const scrollToSection = (id) => {
  const section = document.getElementById(id);
  const offset = section.getBoundingClientRect().top + window.pageYOffset;
  if (section) {
    window.scrollTo({
      top: offset,
      behavior: "smooth",
    });
  }
};

// const scrollTo = (ref) => {
//   const position = ref.current.getBoundingClientRect().top;
//   window.scrollTo({
//     top: position,
//     behavior: "smooth",
//   });
// };

const App = () => {

  const [user, setUser] = useState(null);
  const [hasReloaded, setHasReloaded] = useState(false); // Flag to track reload
  const [displayName, setDisplayName] = useState("");

  const auth = getAuth();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setDisplayName(user.displayName);
        if (!hasReloaded) {
          setHasReloaded(true);
          console.log("window_reloaded");
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the listener when the component unmounts
  }, [1000]); // Empty dependency array ensures the effect runs only once

  useEffect(() => {
    const storedReloadFlag = localStorage.getItem("hasReloaded");
    if (storedReloadFlag) {
      setHasReloaded(true);
      localStorage.removeItem("hasReloaded");
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setDisplayName(user.displayName);
        if (!hasReloaded) {
          setHasReloaded(true);
          localStorage.setItem("hasReloaded", "true"); // Set the flag in localStorage
          console.log("window_reloaded");
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the listener when the component unmounts
  }, []); // Empty dependency array ensures the effect runs only once

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        setUser(null);
        window.location.reload();
        console.log("window_reloaded");
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
  };

  const [language, setLanguage] = useState("en"); // Default language is 'en' (English)

  // Function to handle language change
  const handleLanguageChange = (selectedLanguage) => {
    setLanguage(selectedLanguage);
  };

  const { t } = useTranslation();
  const onChange = (event) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  };

  const servicesRef = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [headerOpen, setHeaderOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (id) => {
    setHeaderOpen(false);
    scrollToSection(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setLoginOpen(false);
    setIsSignUpOpen(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);

  const handleLoginClick = () => {
    setLoginOpen(true);
  };
  const handleSignInClick = () => {
    setIsSignUpOpen(true);
  };

  return (
    <Suspense fallback="Loading...">
      <div className="w-full scroll-smooth pr-0 overflow-x-hidden sm:overflow-visible ">
        <div>
          <div>
            <p></p>
          </div>
          <div className="md:pr-0 px-0 relative flex flex-col gap-0 left-0">
            <div className="flex flex-row justify-between bg-gray-800 py-0 px-1 w-full">
              <div className="sm:hidden text-xs scale-75 pt-1">
                <select
                  name="language"
                  onChange={onChange}
                  className="border-2 border-gray-200 rounded-md"
                >
                  <option value="en">English</option>
                  <option value="hi">Hindi</option>
                </select>
              </div>
              {/* Login and Signup for Mobile */}
              {user ? (
                  <div className="md:hidden flex flex-row rounded-lg bg-gray-800 text-white px-1 py-1 font-semibold hover:bg-gray-700 transition ease-in-out duration-300 text-xs justify-between">
                    <div className="flex flex-row gap-1 items-center">
                      {user.photoURL && (
                        <img
                          src={user.photoURL}
                          className="w-8 h-8 rounded-full"
                        />
                      )}
                      {language === 'en' && (
                      <p className="pr-7">Welcome, {user.displayName} </p>
                      )}
                      {language === 'hi' && (
                      <p className="pr-7">नमस्ते, {user.displayName} </p>
                      )}
                      {/* <p>{user.displayName}</p> */}
                    </div>
                    {language === 'en' && (
                    <button
                      className="ml-6 pt-1 pb-0.5 flex flex-row justify-center transform transition duration-500 ease-in-out hover:text-cyan-400"
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      <MdLogout className="mt-0.5 mr-1 scale-125" />
                      Log Out
                    </button>
                    )}
                    {language === 'hi' && (
                    <button
                      className="ml-6 pt-1 flex flex-row justify-center transform transition duration-500 ease-in-out hover:text-cyan-400"
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      <MdLogout className="mt-0 mr-1 scale-125" />
                      लॉग आउट
                    </button>
                    )}
                  </div>
                ) : (
              <div className="sm:hidden text-xs space-x-1 flex flex-row text-black font-semibold scale-75">
                {language === 'en' && (
                <button className="border-2 border-gray-200 rounded-md px-1 bg-white" onClick={handleLoginClick}>Login</button>
                )}
                {language === 'hi' && (
                <button className="border-2 border-gray-200 rounded-md px-1 bg-white" onClick={handleLoginClick}>लॉगिन</button>
                )}
                {language === 'en' && (
                <button className="border-2 border-gray-200 rounded-md px-1 bg-white" onClick={handleSignInClick}>SignUp</button>
                )}
                {language === 'hi' && (
                <button className="border-2 border-gray-200 rounded-md px-1 bg-white" onClick={handleSignInClick}>साइन अप</button>
                )}
                <LoginForm isOpen={isLoginOpen} isClose={handleClose}/>
                <SignupForm isOpen={isSignUpOpen} isClose={handleClose}/>
              </div>
                )}
            </div>
            <BasicHeader
              language={language}
              onLanguageChange={handleLanguageChange}
            />

            {/* Header */}

            <div
              className="z-20 left-0 sticky top-0 max-h-10"
              style={{ height: "90px" }}
            >
              <div className=" z-50 w-screen lg:w-[100%] left-0 max-h-10">
                <header
                  className="hidden sm:visible flex flex-col sm:flex sm:flex-row sm:justify-between items-start sm:items-center pb-4 h-[15%] md:flex-row mb-4 sm:right-3 sm:left-3 bg-gray-800 z-10 lg:justify-items-end lg:left-0 lg:w-full"
                  style={{ height: "90px" }}
                >
                  <div className="flex">
                    <div className="max-w-4xl mx-auto left-8 ml-4 sm:ml-16 lg:ml-24 mt-4">
                      <div className="flex flex-row">
                        {/* <img src={S} alt="My Image" className=' bg-orange-500 text-white'/> */}
                        <div className="w-14 h-14 bg-orange-500 relative rounded-md items-center justify-center flex">
                          <div className="absolute text-white text-2xl">S</div>
                        </div>
                        <p className="text-2xl ml-3 mt-3 items-center text-white">
                          {" "}
                          {t("sthapna")}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => setHeaderOpen(!headerOpen)}
                    className="text-3xl absolute right-8 top-6 cursor-pointer sm:hidden"
                  >
                    <BiMenu />
                  </button>
                  <div
                    className={`flex flex-wrap font-semibold text-white flex-col mt-4 absolute sm:static sm:z-auto sm:w-auto items-start sm:grid sm:grid-cols-3 sm:gap-4 sm:pr-10 sm:mr-5 sm:pl-3 md:flex md:flex-row md:items-center md:gap-3 md:pr-10 md:mr-5 md:pl-3 lg:flex lg:items-center lg:gap-4 lg:pr-10 lg:mr-5 lg:pl-3 pl-1 transition-all duration-500 bg-gray-800 ease-in h-[70px] ${
                      open
                        ? "left-0 top-[-40px] h-[70px] gap-4 z:200"
                        : "left-[-490px] top-[-490px]"
                    } z-[-1] w-full h-90px max-h-[100px]`}
                  >
                    <a
                      href="#"
                      onClick={() => handleMenuClick("section0")}
                      className="scroll-smooth hover:bg-slate-100 p-2 rounded-md hover:-translate-y-1 ease-in duration-100 hover:text-orange-500"
                    >
                      {t("home")}
                    </a>
                    <a
                      href="#services"
                      onClick={() => handleMenuClick("section1")}
                      className="hover:bg-slate-100 p-2 rounded-md hover:-translate-y-1 ease-in duration-100 hover:text-orange-500"
                    >
                      {t("services")}
                    </a>
                    <a
                      href="#about"
                      onClick={() => handleMenuClick("section2")}
                      className="scroll-smooth hover:bg-slate-100 p-2 rounded-md hover:-translate-y-1 ease-in duration-100 hover:text-orange-500"
                    >
                      {t("aboutUs")}
                    </a>
                    <a
                      href="#whyus"
                      onClick={() => handleMenuClick("section3")}
                      className="scroll-smooth hover:bg-slate-100 p-2 rounded-md hover:-translate-y-1 ease-in duration-100 hover:text-orange-500"
                    >
                      {t("whyUs")}
                    </a>
                    <a
                      href="#gallery"
                      onClick={() => handleMenuClick("section4")}
                      className="hover:bg-slate-100 p-2 rounded-md hover:-translate-y-1 ease-in duration-100 hover:text-orange-500"
                    >
                      {t("gallery")}
                    </a>
                    <a
                      href="#videos"
                      onClick={() => handleMenuClick("section5")}
                      className="hover:bg-slate-100 p-2 rounded-md hover:-translate-y-1 ease-in duration-100 hover:text-orange-500"
                    >
                      {t("videos")}
                    </a>
                    <a
                      href="#testimonials"
                      onClick={() => handleMenuClick("section6")}
                      className="hover:bg-slate-100 p-2 rounded-md hover:-translate-y-1 ease-in duration-100 hover:text-orange-500"
                    >
                      {t("testimonials")}
                    </a>
                    <a
                      href="#contactus"
                      onClick={() => handleMenuClick("section7")}
                      className="hover:bg-slate-100 p-2 rounded-md hover:-translate-y-1 ease-in duration-100 hover:text-orange-500"
                    >
                      {t("contactUs")}
                    </a>
                    <div>
                      <select
                        name="language"
                        onChange={onChange}
                        className="bg-gray-800"
                      >
                        <option value="en">ENGLISH</option>
                        <option value="hi">HINDI</option>
                      </select>
                    </div>
                  </div>
                </header>
              </div>
            </div>
            <div className="h-full">
              <StartImage
                language={language}
                onLanguageChange={handleLanguageChange}
              />
              <div className=" px-1 md:px-8 relative flex flex-col gap-1">
                <div id="section1">
                  <Services
                    language={language}
                    onLanguageChange={handleLanguageChange}
                  />
                </div>
                <div id="section2">
                  <AboutUs
                    language={language}
                    onLanguageChange={handleLanguageChange}
                  />
                </div>
                <div id="section3">
                  <WhyUs
                    language={language}
                    onLanguageChange={handleLanguageChange}
                  />
                </div>
                <div id="section4">
                  <Gallery
                    language={language}
                    onLanguageChange={handleLanguageChange}
                  />
                </div>
                <div id="section5">
                  <Videos
                    language={language}
                    onLanguageChange={handleLanguageChange}
                  />
                </div>
                <div id="section6">
                  <Testimonials />
                </div>
                <Scroll className="fixed right-7 bottom-7 md:right-7 md:bottom-7 sm:right-7 sm:bottom-7 lg:right-12 lg:bottom-9 z-10" />
                <div id="section7">
                  <ContactUs
                    language={language}
                    onLanguageChange={handleLanguageChange}
                  />
                </div>
                
                <div className="sm:hidden py-3 px-10 fixed bottom-0 left-0 right-0 bg-white flex justify-between overflow-x-hidden w-[100%] sm:w-screen">
                  <HiHome
                    className="scale-125 text-gray-700"
                    onClick={scrollToTop}
                  />
                  <a href="mailto:archimaya83@gmail.com"><AiOutlineMail className="scale-125 text-gray-600" /></a>
                  
                  <a href="tel:+91-8890073787">
                    <IoCallOutline className="scale-125 text-gray-600" />
                  </a>
                  <a href="https://maps.google.com/maps/dir//Sthapna+architects+WQ2G%2B78G+Ramnagar+Main+Rd,+Shiv+Puri+Colony,+Sodala+Jaipur,+Rajasthan+302007/@26.9006775,75.7758423,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x396db59e54a6e2b9:0x9781ff1d59d9fd54">
                    <SlLocationPin className="scale-125 text-gray-600" />
                  </a>
                </div>

                {/* <div className="rounded-full p-1 bg-orange-500 text-white hover:bg-orange-300 text-xl fixed right-7 bottom-7 md:right-7 md:bottom-7 sm:right-7 sm:bottom-7 lg:right-12 lg:bottom-9 z-10 scale-150">
            {<TfiHeadphoneAlt />}
          </div> */}
              </div>
            </div>
          </div>
          {/* <Header /> */}
        </div>
        <div className="hidden sm:inline-block">
          <button
            aria-describedby={id}
            variant="contained"
            onClick={handleClick}
            className="rounded-full p-1 bg-orange-500 text-white hover:bg-orange-300 text-xl fixed right-7 bottom-7 md:right-7 md:bottom-7 sm:right-7 sm:bottom-7 lg:right-16 lg:bottom-9 z-10 scale-150"
          >
            {<TfiHeadphoneAlt />}
          </button>
          <Popover
            className="ml-11 fixed"
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorReference="anchorEl"
            // anchorPosition={{ top: 230, left: 650 }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <Typography sx={{ mr: 4 }}>
              <div className="flex flex-row align-center items-center justify-center bg-orange-400 rounded-md">
                <div className="scale-150">
                  <TfiHeadphoneAlt className="mx-6 scale-150 text-white" />
                </div>
                <div className="flex flex-col bg-white pl-4 pr-4 py-4 space-y-4">
                  <div className="space-y-2">
                    {language === "en" && (
                      <p className="font-semibold text-xl pb-2">Contact Us</p>
                    )}
                    {language === "hi" && (
                      <p className="font-semibold text-xl pb-2">संपर्क करें</p>
                    )}
                    <a
                      href="tel:+91-8890073787"
                      className="hover:text-orange-400 ease-in-out transition duration-400"
                    >
                      +91-8890079787
                    </a>
                  </div>
                  <div className="space-y-2">
                    {language === "en" && (
                      <p className="font-semibold text-xl">Mail Us</p>
                    )}
                    {language === "hi" && (
                      <p className="font-semibold text-xl">हमें मेल करें</p>
                    )}
                    <a href="mailto:archimaya83@gmail.com" className="hover:text-orange-400 ease-in-out transition duration-400">
                      archimaya83@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </Typography>
          </Popover>
        </div>
        {/* <Footer /> */}
        {/* <Footer className="sm:bottom-0 bottom-8 w-full sm:w-screen" /> */}
        <div>
                  {/* <LastPage /> */}
                  <div className="mb-4 sm:mb-0 rounded-md bg-[#2C3F46] text-white">
                    {/* <p className="border-black border-2 rounded-md text-center">Map Component</p> */}
                    <Map />
                    <div className="grid grid-cols-1 sm:flex sm:flex-row w-[90%] md:w-[70%] justify-between mb-4 pl-6 py-4 sm:pt-2 sm:mt-4 sm:scale-100 sm:gap-2">
                      <div className="md:inline-block hidden">
                        <div className="flex flex-col gap-1">
                          {language === "en" && (
                            <p className="font-bold text-sm py-2">
                              USEFUL LINKS
                            </p>
                          )}
                          {language === "hi" && (
                            <p className="font-bold text-sm py-2">
                              उपयोगी लिंक्स
                            </p>
                          )}
                          {language === "en" && (
                            <p className="hover:text-orange-500 text-sm">
                              PRIVACY POLICY
                            </p>
                          )}
                          {language === "hi" && (
                            <p className="hover:text-orange-500 text-sm">
                              गोपनीयता नीति
                            </p>
                          )}
                          <a
                            href="#services"
                            onClick={() => handleMenuClick("section1")}
                            className="hover:text-orange-500 text-sm"
                          >
                            {t("services")}
                          </a>
                          <a
                            href="#whyus"
                            onClick={() => handleMenuClick("section3")}
                            className="hover:text-orange-500 text-sm"
                          >
                            {t("whyUs")}
                          </a>
                          <a
                            href="#videos"
                            onClick={() => handleMenuClick("section5")}
                            className="hover:text-orange-500 text-sm"
                          >
                            {t("videos")}
                          </a>
                          <a
                            href="#contactus"
                            onClick={() => handleMenuClick("section7")}
                            className="hover:text-orange-500 text-sm"
                          >
                            {t("contactUs")}
                          </a>
                        </div>
                      </div>
                      <div className="md:inline-block hidden pt-4">
                        <div className="flex flex-col gap-1 sm:mt-6">
                          <p className="hover:text-orange-500 text-sm">
                            {t("home")}{" "}
                          </p>
                          <a
                            href="#about"
                            onClick={() => handleMenuClick("section2")}
                            className="hover:text-orange-500 text-sm"
                          >
                            {t("aboutUs")}
                          </a>
                          <a
                            href="#gallery"
                            onClick={() => handleMenuClick("section4")}
                            className="hover:text-orange-500 text-sm"
                          >
                            {t("gallery")}
                          </a>
                          <a
                            href="#testimonials"
                            onClick={() => handleMenuClick("section6")}
                            className="hover:text-orange-500 text-sm"
                          >
                            {t("testimonials")}
                          </a>
                        </div>
                      </div>
                      <div className="inline-block md:hidden">
                        <p className="font-bold text-sm py-2">USEFUL LINKS</p>
                        <div className="grid grid-cols-2">
                          <div className="flex flex-col gap-1">
                            {language === "en" && (
                              <p className="hover:text-orange-500 text-sm">
                                PRIVACY POLICY
                              </p>
                            )}
                            {language === "en" && (
                              <p className="hover:text-orange-500 text-sm">
                                गोपनीयता नीति
                              </p>
                            )}
                            <a
                              href="#services"
                              onClick={() => handleMenuClick("section1")}
                              className="hover:text-orange-500 text-sm"
                            >
                              {t("services")}
                            </a>
                            <a
                              href="#whyus"
                              onClick={() => handleMenuClick("section3")}
                              className="hover:text-orange-500 text-sm"
                            >
                              {t("whyUs")}
                            </a>
                            <a
                              href="#videos"
                              onClick={() => handleMenuClick("section5")}
                              className="hover:text-orange-500 text-sm"
                            >
                              {t("videos")}
                            </a>
                            <a
                              href="#contactus"
                              onClick={() => handleMenuClick("section7")}
                              className="hover:text-orange-500 text-sm"
                            >
                              {t("contactUs")}
                            </a>
                          </div>
                          <div className="flex flex-col gap-1 sm:mt-6">
                            <a
                              href="#"
                              onClick={() => handleMenuClick("section0")}
                              className="hover:text-orange-500 text-sm"
                            >
                              {t("home")}{" "}
                            </a>
                            <a
                              href="#about"
                              onClick={() => handleMenuClick("section2")}
                              className="hover:text-orange-500 text-sm"
                            >
                              {t("aboutUs")}
                            </a>
                            <p className="hover:text-orange-500 text-sm">
                              {t("gallery")}
                            </p>
                            <a
                              href="#testimonials"
                              onClick={() => handleMenuClick("section6")}
                              className="hover:text-orange-500 text-sm"
                            >
                              {t("testimonials")}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="flex flex-col gap-1 mt-4 sm:mt-0">
                          {language === "en" && (
                            <p className="font-bold text-sm py-2">CONTACT </p>
                          )}
                          {language === "hi" && (
                            <p className="font-bold text-sm py-2">संपर्क </p>
                          )}
                          <div className="md:inline-block hidden">
                            {language === "en" && (
                              <p>Plot No 79, Behind Sodala Thana,</p>
                            )}
                            {language === "hi" && (
                              <p>प्लॉट नंबर 79, सोडाला थाने के पीछे,</p>
                            )}
                            {language === "en" && <p>Shiv Path, Ram Nagar,</p>}
                            {language === "hi" && <p>शिव पथ, राम नगर,</p>}
                            {language === "en" && <p> Sodala, Jaipur,</p>}
                            {language === "hi" && <p> सोडाला, जयपुर,</p>}
                            {language === "en" && <p> 302019, Rajasthan</p>}
                            {language === "hi" && <p> 302019, राजस्थान</p>}
                          </div>
                          <div className="md:hidden">
                            {language === "en" && (
                              <p>
                                Plot No 79, Behind Sodala Thana, Shiv Path, Ram
                                Nagar, Sodala, Jaipur, 302019, Rajasthan
                              </p>
                            )}
                            {language === "hi" && (
                              <p>
                                प्लॉट नंबर 79, सोडाला थाना के पीछे, शिव पथ, राम
                                नगर, सोडाला, जयपुर, 302019, राजस्थान
                              </p>
                            )}
                          </div>
                          <p className="hover:text-orange-500">
                            +91-8890079787
                          </p>
                          <p className="hover:text-orange-500">
                            archimaya83@gmail,com
                          </p>
                        </div>
                      </div>
                      <div>
                        <div className="flex flex-col mt-4 sm:mt-0">
                          {language === "en" && (
                            <p className="font-bold text-sm py-2">CONNECT</p>
                          )}
                          {language === "hi" && (
                            <p className="font-bold text-sm py-2">जुड़ें</p>
                          )}
                          <a href="https://www.justdial.com/Jaipur/Sthapana-Behind-Sodala-Thana-Sodala/0141PX141-X141-180125131502-G6Y9_BZDET" 
                             className="font-bold text-xl mt-8 hover:bg-orange-500 text-white rounded-full text-center py-1 px-2 absolute bg-black transform ease-in-out duration-300">
                            Jd
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="md:pt-2 pt-12 pl-3 pb-2">
                      <p className="text-gray-500">
                        © Copyrights 2023 - 2024.Sthapana.All Rights Reserved.
                      </p>
                    </div>
                  </div>
                </div>
      </div>
    </Suspense>
  );
};

export default App;
